/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusTagKontextEnum } from '../../models/lexplus-tag-kontext-enum';
import { LexplusTagMiniDto } from '../../models/lexplus-tag-mini-dto';

export interface TagsControllerFindForKontextV1$Params {
  kontextID: number;
  kontext: LexplusTagKontextEnum;
}

export function tagsControllerFindForKontextV1(http: HttpClient, rootUrl: string, params: TagsControllerFindForKontextV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusTagMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, tagsControllerFindForKontextV1.PATH, 'get');
  if (params) {
    rb.path('kontextID', params.kontextID, {});
    rb.path('kontext', params.kontext, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusTagMiniDto>>;
    })
  );
}

tagsControllerFindForKontextV1.PATH = '/v1/tags/{kontext}/{kontextID}';
